import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

export const branchApi = {
  async listBranches(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/branches', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createBranch(payload) {
    const response = await apiClient.post('/branches', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateBranch(branchId, payload) {
    const response = await apiClient.put(`/branches/${branchId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async deleteBranch(branchId) {
    const response = await apiClient.delete(`/branches/${branchId}`, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },
};

export function resolveBranchApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process branch request.');
}
